module.exports = require('./helpers/bundle-url').getBundleURL('geQvc') + "find-ga-code.6fbdfe8f.png";